import React, { useState } from "react";
import WalletAddress from "../components/WalletAddress";
import { api } from "../utils/axiosInstance";
import CounterBox from "../components/CounterBox";
import { toast } from "react-toastify";

const WalletAddressPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [maticAddress, setMaticAddress] = useState("");
  const [tokenValue, setTokenValue] = useState(null);

  const onSubmit = () => {
    setIsLoading(true);
    api
      .post("/spin", { user_address: maticAddress })
      .then((res) => {
        console.log(res);
        setTokenValue(res.data.amount);
      })
      .catch((err) => {
        if (err.status === 400) {
          toast.error("Wallet has already spun and claimed a reward!");
        }
      })
      .finally(() => setIsLoading(false));
  };
  return (
    <>
      {tokenValue ? (
        <CounterBox tokenValue={tokenValue} />
      ) : (
        <WalletAddress
          isLoading={isLoading}
          maticAddress={maticAddress}
          setMaticAddress={setMaticAddress}
          onSubmit={onSubmit}
        />
      )}
    </>
  );
};

export default WalletAddressPage;
